import { useState } from "react";
import { Cpu, Settings2, Activity } from "lucide-react";
import ProviderConfigTable from "./ProviderConfigTable";
import UsageLogsTable from "./UsageLogsTable";

type Sub = "config" | "logs";

const AIOperations = () => {
  const [sub, setSub] = useState<Sub>("config");

  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center gap-2 mb-1">
          <Cpu size={20} style={{ color: "hsl(207 68% 60%)" }} />
          <h2 className="text-xl font-semibold" style={{ color: "hsl(0 0% 95%)" }}>AI Operations</h2>
        </div>
        <p className="text-sm" style={{ color: "hsl(0 0% 55%)" }}>
          Centralized provider/model routing, fallbacks, and observability for every AI workflow in Elevate.
          Every AI call across Content Ops, SEO, editorial tools, embeddings, and the contact form routes through
          this configuration.
        </p>
      </div>

      <div className="flex gap-1 border-b" style={{ borderColor: "hsl(0 0% 16%)" }}>
        <button
          onClick={() => setSub("config")}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium border-b-2 transition-colors"
          style={{
            borderColor: sub === "config" ? "hsl(207 68% 50%)" : "transparent",
            color: sub === "config" ? "hsl(0 0% 95%)" : "hsl(0 0% 55%)",
          }}
        >
          <Settings2 size={14} /> Provider Config
        </button>
        <button
          onClick={() => setSub("logs")}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium border-b-2 transition-colors"
          style={{
            borderColor: sub === "logs" ? "hsl(207 68% 50%)" : "transparent",
            color: sub === "logs" ? "hsl(0 0% 95%)" : "hsl(0 0% 55%)",
          }}
        >
          <Activity size={14} /> Usage & Observability
        </button>
      </div>

      {sub === "config" ? <ProviderConfigTable /> : <UsageLogsTable />}
    </div>
  );
};

export default AIOperations;
